<template>
  <div class="filter-section">
    <ul
      class="filter-section__list"
      :class="{
        'filter-section__list--active': openFilterId !== '',
        'filter-section__list--is-pc': isPc,
      }"
    >
      <li class="filter-section__item" ref="placeFilter">
        <atom-dropdown
          :placeholder="$tc('LinkPage.MotorsportCalendarPage.filter.circuitPlaceholder')"
          :menuList="placeList"
          :selectedOptions="selectedPlaceOptions"
          :isOpenMenu="openFilterId === 'place'"
          :maxHeight="placeFilterMaxHeight"
          @onClickCurrent="handleFilterCurrentClicked('place')"
          @onClickOption="handleFilterPlaceOptionClicked"
        />
      </li>
      <li class="filter-section__item" ref="categoryFilter">
        <atom-dropdown
          :placeholder="$tc('LinkPage.MotorsportCalendarPage.filter.categoryPlaceholder')"
          :menuList="categoryList"
          :selectedOptions="selectedCategoryOptions"
          :isOpenMenu="openFilterId === 'category'"
          :maxHeight="categoryFilterMaxHeight"
          @onClickCurrent="handleFilterCurrentClicked('category')"
          @onClickOption="handleFilterCategoryOptionClicked"
        />
      </li>
    </ul>
    <div
      class="filter-section__overlay"
      v-if="openFilterId !== ''"
      @click="handleOverlayClicked"
    ></div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref, Ref } from '@vue/composition-api'
import AtomDropdown, { DropDownDataType } from '@/components/atoms/AtomDropdown.vue'
import StoreUtil from '@/store/StoreUtil'
import { OpenFilterIdType } from '@/store/stores/pageStore/LinkPage/CalendarPageStore'
import DeviceInfo from '@/util/DeviceInfo'

export default defineComponent({
  name: 'CalendarFilterSection',
  components: { AtomDropdown },
  props: {
    placeList: {
      type: Array as PropType<DropDownDataType[]>,
      default: () => [],
    },
    categoryList: {
      type: Array as PropType<DropDownDataType[]>,
      default: () => [],
    },
  },
  setup() {
    const calendarPageStore = StoreUtil.useStore('CalendarPageStore')

    const placeFilter = ref<HTMLInputElement | null>(null)
    const categoryFilter = ref<HTMLInputElement | null>(null)

    const placeFilterMaxHeight = computed(
      () =>
        `calc(100svh - 36px - 48px - 8px - ${placeFilter.value?.getBoundingClientRect().top}px)` ||
        'none',
    )
    const categoryFilterMaxHeight = computed(
      () =>
        `calc(100svh - 36px - 48px - 8px - ${
          categoryFilter.value?.getBoundingClientRect().top
        }px)` || 'none',
    )

    /** PCブラウザかどうか */
    const isPc = DeviceInfo.isForPC()

    const handleFilterCurrentClicked = (filterId: OpenFilterIdType) => {
      calendarPageStore.openFilterId.value =
        calendarPageStore.openFilterId.value === filterId ? '' : filterId
    }

    const handleFilterPlaceOptionClicked = (option: DropDownDataType) => {
      calendarPageStore.openFilterId.value = ''
      if (calendarPageStore.selectedPlaceOptions.value.includes(option)) {
        calendarPageStore.selectedPlaceOptions.value =
          calendarPageStore.selectedPlaceOptions.value.filter((item) => item.id !== option.id)
        return
      }
      calendarPageStore.selectedPlaceOptions.value = [
        ...calendarPageStore.selectedPlaceOptions.value,
        option,
      ]
    }
    const handleFilterCategoryOptionClicked = (option: DropDownDataType) => {
      calendarPageStore.openFilterId.value = ''
      if (calendarPageStore.selectedCategoryOptions.value.includes(option)) {
        calendarPageStore.selectedCategoryOptions.value =
          calendarPageStore.selectedCategoryOptions.value.filter((item) => item.id !== option.id)
        return
      }
      calendarPageStore.selectedCategoryOptions.value = [
        ...calendarPageStore.selectedCategoryOptions.value,
        option,
      ]
    }
    const handleOverlayClicked = () => {
      calendarPageStore.openFilterId.value = ''
    }

    return {
      placeFilter,
      placeFilterMaxHeight,
      categoryFilter,
      categoryFilterMaxHeight,
      isPc,
      handleFilterCurrentClicked,
      handleFilterPlaceOptionClicked,
      handleFilterCategoryOptionClicked,
      handleOverlayClicked,
      openFilterId: calendarPageStore.openFilterId as Ref<OpenFilterIdType>,
      selectedPlaceOptions: calendarPageStore.selectedPlaceOptions as Ref<DropDownDataType[]>,
      selectedCategoryOptions: calendarPageStore.selectedCategoryOptions as Ref<DropDownDataType[]>,
    }
  },
})
</script>

<style scoped lang="scss">
.filter-section {
  text-align: center;

  &__list {
    display: flex;
    gap: 10px;
    flex-direction: column;

    &--active {
      position: relative;
      z-index: 4;
    }

    &--is-pc {
      flex-direction: row;
    }
  }

  &__item {
    width: 100%;
  }

  &__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 3;
  }
}
</style>
